import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { logoutUser } from 'actions/user';

import Modal from 'components/Modal';

export class ConfirmCancelCreateModal extends Component {
  static displayName = 'ConfirmCancelCreateModal';

  handleQuit = () => {
    const { dispatch, history } = this.props;
    // Log the user out, removing their token; this will bring them back to login
    dispatch(logoutUser(history));
  };

  render = () => {
    const {
      isOpen,
      onRequestClose,
    } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
      >
        <div>
          <h1 className="heading heading--2 heading--inverse">
            Quit character creation?
          </h1>
          <p>
            Are you sure you want to quit and go back to login?
          </p>
          <div className="buttons">
            <button
              className="button button--primary"
              onClick={this.handleQuit}
            >
              Quit
            </button>
            <button
              className="button button--tertiary"
              onClick={onRequestClose}
              type="button"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

ConfirmCancelCreateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default withRouter(connect()(ConfirmCancelCreateModal));